import { BacktestList } from '@/features/decisions/components/backtests/BacktestList';

export function BacktestResults() {
  return <BacktestList />;
}
